var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'TT commons';\n  src: url(" + escape(require("./TTCommons.ttf")) + ") format('truetype');\n}\n@font-face {\n  font-family: 'TT commons pro';\n  src: url(" + escape(require("./TypeType - TT Commons Pro Medium.ttf")) + ") format('truetype');\n}\n\n@font-face {\n  font-family: 'Demibold';\n  src: local('Demibold'), url(" + escape(require("./Demibold.ttf")) + ") format('ttf');\n}", ""]);

// exports
